import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import selectAolName from 'redux/selectors/selectAolName'

const DocumentsDropdown = ({
  dealId,
  documents,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' }
}) => {
  const aol = useSelector(selectAolName)
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <Paper className='bg-white black br0'>
      <Button
        aria-controls='simple-menu'
        aria-haspopup='true'
        onClick={handleClick}
        classes={{ root: 'ttc br0' }}
        className='w-100'
      >
        <div className='flex items-center'>
          <PictureAsPdfIcon className='grey' />
          <span className='mh4'>
            View more documents for this deal
          </span>
        </div>
      </Button>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={anchorOrigin}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {documents.map(({ documentType: { displayName }, id: docId }) => (
          <MenuItem key={docId} data-testid='more-documents-menu-item'>
            <a
              className='w-100 no-underline color-inherit'
              href={url(MW_DEAL_DETAILS, { aol, dealId }, { docId })}
              data-event-category='Markets'
              data-event-action='Change Document'
              data-event-label={`${displayName} - ${docId}`}
            >
              {displayName}
            </a>
          </MenuItem>
        ))}
      </Menu>
    </Paper>
  )
}

export default DocumentsDropdown
